const WalletModule = () => import(/* webpackChunkName: "wallet-module" */ './views/Module.vue');
const WalletDeposit = () => import(/* webpackChunkName: "wallet-deposit" */ './views/WalletDeposit.vue');
const DepositPaymentMethod = () => import(/* webpackChunkName: "wallet-deposit" */ './views/DepositPaymentMethod.vue');
const WalletWithdraw = () => import(/* webpackChunkName: "add-account" */ './views/WalletWithdraw.vue');
const Transactions = () => import(/* webpackChunkName: "profit-loss" */ './views/Transactions.vue');
const TransactionDetails = () => import(/* webpackChunkName: "profit-loss" */ './views/TransactionDetails.vue');

const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
        {
            path: 'wallet-deposit',
            name: 'wallet-deposit',
            component: WalletDeposit,
        },
        {
            path: 'deposit-payment',
            name: 'deposit-payment',
            component: DepositPaymentMethod,
        },
        {
            path: 'wallet-withdraw',
            name: 'wallet-withdraw',
            component: WalletWithdraw,
        },
        {
            path: 'transactions',
            name: 'Transactions',
            component: Transactions
        },
        {
            path: 'transaction-details/:id',
            name: 'TransactionDetails',
            component: TransactionDetails
        },
    ],
}

export default WalletRoutes;